module.exports = __webpack_public_path__ + "img/AyudaFormulario.174f896e.png";